/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState, useCallback, useContext } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import { companysDataType } from '../../types/customerDataType';
import plantLayoutColumns from '../../types/plantLayoutDataTypeCustom';
import help from './company-home.help';
import translations from './i18n';
import { all } from '@plasma/ui.packages.all';
import { apiUriMasterDataHttp, apiUriProductFamilyHttp } from '../../services/conf/apiConf';

import { PlantLayoutContext } from '../../index'; // Adjust path


interface Item {
  product: string[];
  size: string[];
}

function useCompanyHomeHook(props) {
  // Resource and help bundles
  useResourceBundle(translations, undefined, 'f7caf6cc-643b-4a95-b62b-f8cc1a20bff2');
  useHelpBundle(help);

  // Translation hook
  const { t } = useTranslation();
  const plantLayoutFromMemory = useContext(PlantLayoutContext);

  // State declarations
  const [allProductFamiliesList, setAllproductfamiliesList] = useState([]);
  const [selectedBilletOption, setselectedBilletOption] = useState([]);
  const [selectedOption, setSelectedOption] = useState('FAMILY');
  const [billetData,setBilletData] = useState('DEFAULT')
  const [productValue, setProductValue] = useState(undefined);
  const [sizeValue, setSizeValue] = useState(undefined);
  const [familyValue, setFamilyValue] = useState(undefined);
  const [selectedFamilyProductType, setSelectedFamilyProductType] = useState('');
  const [dataForColumns, setDataForColumns] = useState<any>([]);
  const [columnNames, setColumnNames] = useState(plantLayoutColumns([]));
  const [addedItems, setAddedItems] = useState([]);
  const [addedFamily, setAddedFamily] =useState ([]);
  const [selectedItemIndices, setSelectedItemIndices] = useState([]);
  const [productFamiliesList, setProductFamiliesList] = useState([]);
  const [productTypesList, setProductTypesList] = useState([]);
  const [familyProductDescription_optionsList, setFamilyProductDescription_optionsList] = useState([]);
  const [selectedProductDescriptions_optionsList, setSelectedProductDescriptions_optionsList] = useState([]);
  const [allproducts, setallproducts] = useState([]);
  const [hiddenColumns] = useState(['id', 'displayseq', 'drawingnumber', 'isactive', 'remarks', 'toc', 'tom', 'mop', 'positionnumber','quantityredressed','consumablecodeext2']);
  const [sizeArray, setSizeArray] = useState([]);
  const [sideOpen, setSideOpen] = useState(false);
  const [showDifferences, setshowDifferences] = useState(false);

  useEffect(()=>{
    fetchAllDataGet_byApiName('GetMasterProductDetails', apiUriMasterDataHttp())
    .then((response) => {
      const allProductTypes = response.map((oneItem) => oneItem.producttype);
      const uniqueProductTypes = Array.from(new Set(allProductTypes));
      //console.log(uniqueProductTypes);
      setallproducts(response);
      setProductTypesList(uniqueProductTypes);
    })
    .catch((error) => {
      console.log('Error fetching plant layout data', error);
    });


    fetchAllDataGet_byApiName('GetMasterInputMaterials', apiUriMasterDataHttp())
      .then((response) => {
        const billetOption= response.map((item)=> item.materialcode)
        setselectedBilletOption(billetOption);
      })
      .catch((error) => {
        console.log('Error fetching plant layout data', error);
      });

    // fetchAllDataGet_byApiName('GetPlantlayout')
    // .then((response) => {
    //   setDataForColumns(response);
    // })
    // .catch((error) => {
    //   console.log('Error fetching plant layout data', error);
    // });

    setDataForColumns(plantLayoutFromMemory?.layoutData ?? [])

    fetchAllDataGet_byApiName('GetAllProductsFamilies', apiUriProductFamilyHttp())
    .then((response) => {
      if (Array.isArray(response) && response.length > 0) {
        setAllproductfamiliesList(response);
        const familyNames = response.map((item) => item.productfamilyname);
        setProductFamiliesList(familyNames);
      } else {
        console.log('No responseData in the API response.');
      }
    })
    .catch((error) => {
      console.log('Error fetching data', error);
    });

  },[]);


useEffect(() => {
  if(productFamiliesList && productFamiliesList.length> 0){
    handleFamilyChange(productFamiliesList[0]);
  }
},[productFamiliesList]);

useEffect(() => {
  const proddescription=[];
  allProductFamiliesList.forEach((item)=>{
    if(item.productfamilyname=== familyValue){
      proddescription.push(item.familyproducts.productdescription);
    }
  })
  setFamilyProductDescription_optionsList(proddescription);
},[familyValue]);


const getItemFromAddedITems = (product: string, size: string) =>{
  let returnItem = {}
  addedItems?.forEach(oneAddedItem => {
    if(oneAddedItem.product === product && oneAddedItem.size === size){
      returnItem = {product: oneAddedItem.product, size: oneAddedItem.size}
    }
  });
  return returnItem;
}

const getONeCOnsumableFrom_apiData_Consumables = (apiData_consumables) => {
  let returnConsumable = {}
  apiData_consumables?.forEach(consumable => {
    if(consumable.billetid === billetData || 'DEFAULT'){
      returnConsumable = consumable;
    }
  });
  return returnConsumable;
}


const calculateDifferences = (formattedData) => {

  const actualColumns = plantLayoutColumns([])?.map((item) => {return item.accessor});

  const allColumns = formattedData?.reduce((uniqueFields, rowData) => {
    Object.keys(rowData)?.forEach((key) => {
      if (!uniqueFields?.includes(key)) {
        uniqueFields.push(key);
      }
    });
    return uniqueFields;
  }, []);


  const differentColumns = allColumns?.filter(column => !actualColumns?.includes(column) && column !== 'id');
  const primaryColumnConsideration = differentColumns[0];
  const restOfTheColumns = differentColumns?.filter(column => column !== primaryColumnConsideration);

  const displayDataForColumnsWithDifferences = formattedData?.map((oneDataRow) => {
    const newDataRow = { ...oneDataRow }; // Create a new object to avoid mutating the original data

    restOfTheColumns?.forEach(column => {
      if (oneDataRow[column] === oneDataRow[primaryColumnConsideration]) {
        newDataRow[column] = ''; // Make the data blank if it's the same as in primaryColumnConsideration
      }
    });

    return newDataRow;
  });

  return displayDataForColumnsWithDifferences;
}


    const displayDataForColumns = useMemo<companysDataType[]>(() => {
      let formattedData: companysDataType[] = [];

      const newColumnNames = [];

      if (dataForColumns) {

        formattedData = dataForColumns?.map((apiData: any) => {
          const extraFields = {}
          if(apiData.consumables && apiData.consumables.length > 0){

            const oneConsumable = getONeCOnsumableFrom_apiData_Consumables(apiData.consumables);

              if(oneConsumable.billetid === billetData || 'DEFAULT'){
                extraFields['consumablecode'] = oneConsumable.consumabledescription;
                extraFields['quantityinstalled'] = oneConsumable.quantityinstalled;


                oneConsumable?.productprofiles?.map((oneProduct) => {

                  const oneAddedItem = getItemFromAddedITems(oneProduct.producttype, oneProduct.productdescription);

                  if(oneProduct.producttype === oneAddedItem.product && oneProduct.productdescription === oneAddedItem.size){

                    const newFieldName = oneProduct.producttype + " " + oneProduct.productdescription;

                    const newColumnDescription = {
                      Header: newFieldName,
                      accessor: newFieldName,
                      editType: null,
                      options: [],
                    }
                      extraFields[newFieldName] = oneConsumable.consumablecodeext;
                      if(!newColumnNames.includes(newColumnDescription) && !columnNames.includes(newColumnDescription)){newColumnNames.push(newColumnDescription);}
                  }
                })

              }
          }
          return( {     id: apiData.id,
                        displayseq: apiData.displayseq,
                        areacode: apiData.areacode,
                        zonecode: apiData.zonecode,
                        equipmentcode: apiData.equipmentcode,
                        positionnumber: apiData.positionnumber,
                        quantityinstalled: apiData.quantityinstalled,
                        quantityredressed: apiData.quantityredressed,
                        drawingnumber: apiData.drawingnumber,
                        ...extraFields
                    }  )
        });
      }

    const uniqueRecords = Array.from(new Set(newColumnNames.map(JSON.stringify))).map(JSON.parse);

    setColumnNames([...plantLayoutColumns(),...uniqueRecords]);

    const formateedAndSortedData = formattedData.sort((a, b) => a.displayseq - b.displayseq)

    if(showDifferences){
      const dataWithDifferences = calculateDifferences(formateedAndSortedData);
      return dataWithDifferences.sort((a, b) => a.displayseq - b.displayseq);
    }
    else{
      return formateedAndSortedData;
    }

    }, [dataForColumns, billetData, addedItems, showDifferences]);


// Function to handle Product Type Selection
const handleProductTypeSelection = useCallback((productType) => {

  const selectedProductDescriptions = allproducts.map((eachProduct) => {

    if(eachProduct.producttype === productType){

      return eachProduct.productdescription;
    }
  }).filter(element => element !== undefined);
  //console.log(selectedProductDescriptions);
  setSelectedProductDescriptions_optionsList(selectedProductDescriptions);
}, [allproducts]);


  // Handle Selection Change
  const handleSelectChange = (value) => {
    setSelectedOption(value);
    setProductValue(undefined);
    setSizeValue(undefined);
    setFamilyValue(undefined);
    //setselectedBilletOption(undefined);
   // Clear added items and selected item indices
    setAddedItems([]);
    setSelectedItemIndices([]);
    setAddedFamily([]);
  };

  // Handle Family Change
  const handleFamilyChange = (value) => {

    let selectionDescriptions = [];

    const selectedFamilyProductType_loc = allProductFamiliesList?.map((eachProductFamilily) =>{
      if(eachProductFamilily.productfamilyname === value){
        selectionDescriptions = eachProductFamilily.familyproducts.productdescription;
        return eachProductFamilily;
      }
    }).filter((element) => element !== undefined)[0].familyproducts.producttype;

    setSelectedFamilyProductType(selectedFamilyProductType_loc);
    const newList = [];

    selectionDescriptions.map((eachDecription) => {
      const oneItem = { product: selectedFamilyProductType_loc, size: eachDecription }
      newList.push(oneItem);
    })

    setAddedItems(newList);

    setFamilyValue(value);
    setAddedFamily([]);
    setSizeArray([]);
    setFamilyProductDescription_optionsList([]);
  };

  // Handle Product Change
  const handleProductChange = (value) => {

    setProductValue(value);
    // setAddedItems([]);
    // setSizeArray([]);
    // setSizeValue(undefined);

    if (value) {
      handleProductTypeSelection(value);
    }
  };

  // Handle Size Change
  const handleSizeChange = (value) => {
    setSizeValue(value);
  };

  // Handle adding items
  const handleAdd = useCallback(() => {
    if ((productValue?.length || familyValue?.length > 0) && sizeValue?.length > 0) {
      setAddedItems((currentItems) => {
        return [ { product: selectedOption === 'FAMILY' ? selectedFamilyProductType : productValue, size: sizeValue }, ...currentItems,]
      }
      );
      // Clear the fields after adding
      setSizeArray(prevSizeArray => [...prevSizeArray, ...sizeValue]);
     // setProductValue([]);
      setSizeValue([]);
      console.log(sizeArray);
    }
  }, [familyValue, productValue, sizeValue]);


  useEffect(()=>{
    const filteredArr = familyProductDescription_optionsList.filter((value) => !sizeArray.includes(value));
    setFamilyProductDescription_optionsList(filteredArr);
    const filteredArr1 = selectedProductDescriptions_optionsList.filter((value) => !sizeArray.includes(value));
    setSelectedProductDescriptions_optionsList(filteredArr1);

  },[sizeArray])

  // Handle removing selected items
    const handleRemove = (indexToRemove) => {
      setAddedItems((currentItems) => {
        const removedItem = currentItems[indexToRemove];
            if(selectedOption === 'FAMILY'){
              setFamilyProductDescription_optionsList((currentDesc)=>[...currentDesc, removedItem.size]);

            }else{
              setSelectedProductDescriptions_optionsList((currentDesc) => [removedItem.size,...currentDesc]);
            }
        const updatedItems = currentItems.filter((_, index) => index !== indexToRemove);

        return updatedItems;
      });

    };


    const handleSelectBilletChange = (value) => {
      setBilletData(value);
    }


    const handleshowDifferences = (value: boolean) => {
      setshowDifferences(!showDifferences);
    }


  return {
    t,
    selectedOption,
    productValue,
    sizeValue,
    familyValue,
    dataForColumns,
    columnNames,
    addedItems,
    selectedItemIndices,
    productFamiliesList,
    productTypesList,
    selectedProductDescriptions_optionsList,
    familyProductDescription_optionsList,
    billetData,
    addedFamily,
    sideOpen,
    hiddenColumns,
    displayDataForColumns,
    selectedBilletOption,
    selectedFamilyProductType,
    showDifferences,
    // Functions
    setSelectedOption,
    setProductValue,
    setSizeValue,
    setFamilyValue,
    setDataForColumns,
    setColumnNames,
    setAddedItems,
    setSelectedItemIndices,
    setProductFamiliesList,
    setProductTypesList,
    // Handlers
    handleSelectChange,
    handleFamilyChange,
    handleProductChange,
    handleSizeChange,
    handleAdd,
    handleRemove,
    handleSelectBilletChange,
    setAddedFamily,
    setSideOpen,
    handleshowDifferences,
  };
}

export default useCompanyHomeHook;
